import React, { ReactNode } from 'react';

// The page's copy marks a kettei model's name as *name* and a literal as `code`. A name is
// always lowercase and set in the display serif's italic, so core or dot never reads as the
// everyday word; a literal is set in the mono.
export function rich(text: string): ReactNode {
  const parts = text.split(/(\*[^*]+\*|`[^`]+`)/);
  if (parts.length === 1) return text;
  return parts.map((part, i) => {
    if (part.startsWith('*')) return <em key={i} className="oh-model-name">{part.slice(1, -1)}</em>;
    if (part.startsWith('`')) return <code key={i} className="oh-literal">{part.slice(1, -1)}</code>;
    return part;
  });
}

export default rich;
